/**
 * #115: one vocabulary for the verdict tag shown in a review card's header.
 * Every card (scope C1–C5, control exceptions, CUECs, subservice orgs) derives
 * its header tag through these helpers so the wording reads consistently and is
 * rendered as one blue verdict badge. A verdict tag shows only once a card is
 * Done (#114) — an open card shows just its Open status.
 */

/** Control-exception conclusion → header verdict. */
const EXCEPTION_CONCLUSION: Record<string, string> = {
  mitigated_service_org: "Mitigated by Service Org",
  mitigated_user_org: "Mitigated by User Org",
  unmitigated: "Unmitigated",
  na: "N/A",
};
export function exceptionVerdict(conclusion: string | null | undefined): string | null {
  if (!conclusion) return null;
  return EXCEPTION_CONCLUSION[conclusion] ?? conclusion;
}

/** CUEC coverage → header verdict. */
const CUEC_COVERAGE: Record<string, string> = {
  full: "Covered",
  partial: "Partial coverage",
  none: "No coverage",
  na: "N/A",
};
export function cuecVerdict(coverage: string | null | undefined): string | null {
  if (!coverage) return null;
  return CUEC_COVERAGE[coverage] ?? null;
}

/** Subservice-organization decision → header verdict (C6). */
export function subserviceVerdict(opts: {
  treatment?: string;
  decided?: boolean;
  coveredBy?: string;
  coverName?: string;
}): string | null {
  if (opts.treatment === "inclusive") return "Inclusive — covered";
  if (opts.coveredBy) return `SOC 1: ${opts.coverName ?? "linked"}`;
  if (opts.decided === true) return "SOC 1 requested";
  if (opts.decided === false) return "Documented N/A";
  return null;
}
